@if(pageInfo?.['title'] != 'Analytical' && pageInfo?.['title'] != 'eCommerce'){
<div class="bg-light-primary rounded p-y-10 p-x-24 m-b-10 overflow-hidden">
  <div class="row">
    <div class="col-sm-12">
      <h4 class="page-title m-0 f-s-20 f-w-700 m-b-10">
        {{ pageInfo?.['title'] }}
      </h4>
      <div class="d-flex justify-content-start align-items-center">
        <ul class="breadcrumb">
          @for (url of pageInfo?.['urls']; track url.url;let index = $index,last= $last ) {
          @if(!last){
          <li class="breadcrumb-item">
            <a *ngIf="url.url" [routerLink]="url.url">{{ url.title }}&nbsp;>&nbsp;</a>
            <span *ngIf="!url.url">{{ url.title }}</span>
          </li>
          }@else {
          <!-- <li class="breadcrumb-item">
            <i-tabler name="circle-filled" class="icon-8"></i-tabler>
          </li> -->
          <li class="breadcrumb-item active">{{ url.title }}</li>
          } }
        </ul>
      </div>
    </div>
  </div>
</div>
}